import { render, staticRenderFns } from "./Suites.vue?vue&type=template&id=6dee2cec&scoped=true&"
import script from "./Suites.vue?vue&type=script&lang=js&"
export * from "./Suites.vue?vue&type=script&lang=js&"
import style0 from "./Suites.vue?vue&type=style&index=0&id=6dee2cec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dee2cec",
  null
  
)

export default component.exports